export enum IAction {
	None = 0,
	Insert = 1,
	Update = 2,
	Delete = 3,
}
